// The coach's morning card (spec §13.15, M5.3): a coach_message with
// body.kind 'morning_card', at most two sentences about today. In the thread
// it reads as the coach's note for that day, and Home shows today's (Sam,
// 2026-10-26: not on the calendar too, whose grid comes first). Labelled "Note for the day", not "This morning": the
// morning pass runs when the athlete first opens the app that day, which may
// be the afternoon (planning review gap 11).
import React from 'react';
import { Sunrise } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function MorningCard({ item, className }) {
  const b = item?.body || {};
  if (!b.text) return null;
  return (
    <div role="note" aria-label="Your coach's note for the day"
      className={cn('rounded-xl border border-accent-tint-border bg-accent-tint px-3.5 py-2.5 text-sm text-accent-default', className)}>
      <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-accent-default">
        <Sunrise size={13} /> Note for the day
      </div>
      <p className="m-0 mt-1 leading-relaxed">{b.text}</p>
    </div>
  );
}
